import type { LevelDef } from '../levels';

// Temple — 25 types × 3 = 75 tiles
// Layer 0: 5×8 base (40)   Layer 1: 4×6 middle (24)   Layer 2: 3×3 upper (9)   Layer 3: 1×2 peak (2)
export const LEVEL_TEMPLE: LevelDef = {
  id: 'level-temple',
  name: 'Temple',
  seed: 2716,
  tileTypes: 25,
  maxRowX2: 8,
  maxColX2: 14,
  placements: [
    { rowX2: 0, colX2: 0,  layer: 0 }, { rowX2: 0, colX2: 2,  layer: 0 }, { rowX2: 0, colX2: 4,  layer: 0 },
    { rowX2: 0, colX2: 6,  layer: 0 }, { rowX2: 0, colX2: 8,  layer: 0 }, { rowX2: 0, colX2: 10, layer: 0 },
    { rowX2: 0, colX2: 12, layer: 0 }, { rowX2: 0, colX2: 14, layer: 0 },
    { rowX2: 2, colX2: 0,  layer: 0 }, { rowX2: 2, colX2: 2,  layer: 0 }, { rowX2: 2, colX2: 4,  layer: 0 },
    { rowX2: 2, colX2: 6,  layer: 0 }, { rowX2: 2, colX2: 8,  layer: 0 }, { rowX2: 2, colX2: 10, layer: 0 },
    { rowX2: 2, colX2: 12, layer: 0 }, { rowX2: 2, colX2: 14, layer: 0 },
    { rowX2: 4, colX2: 0,  layer: 0 }, { rowX2: 4, colX2: 2,  layer: 0 }, { rowX2: 4, colX2: 4,  layer: 0 },
    { rowX2: 4, colX2: 6,  layer: 0 }, { rowX2: 4, colX2: 8,  layer: 0 }, { rowX2: 4, colX2: 10, layer: 0 },
    { rowX2: 4, colX2: 12, layer: 0 }, { rowX2: 4, colX2: 14, layer: 0 },
    { rowX2: 6, colX2: 0,  layer: 0 }, { rowX2: 6, colX2: 2,  layer: 0 }, { rowX2: 6, colX2: 4,  layer: 0 },
    { rowX2: 6, colX2: 6,  layer: 0 }, { rowX2: 6, colX2: 8,  layer: 0 }, { rowX2: 6, colX2: 10, layer: 0 },
    { rowX2: 6, colX2: 12, layer: 0 }, { rowX2: 6, colX2: 14, layer: 0 },
    { rowX2: 8, colX2: 0,  layer: 0 }, { rowX2: 8, colX2: 2,  layer: 0 }, { rowX2: 8, colX2: 4,  layer: 0 },
    { rowX2: 8, colX2: 6,  layer: 0 }, { rowX2: 8, colX2: 8,  layer: 0 }, { rowX2: 8, colX2: 10, layer: 0 },
    { rowX2: 8, colX2: 12, layer: 0 }, { rowX2: 8, colX2: 14, layer: 0 },
    { rowX2: 1, colX2: 1,  layer: 1 }, { rowX2: 1, colX2: 3,  layer: 1 }, { rowX2: 1, colX2: 5,  layer: 1 },
    { rowX2: 1, colX2: 7,  layer: 1 }, { rowX2: 1, colX2: 9,  layer: 1 }, { rowX2: 1, colX2: 11, layer: 1 },
    { rowX2: 3, colX2: 1,  layer: 1 }, { rowX2: 3, colX2: 3,  layer: 1 }, { rowX2: 3, colX2: 5,  layer: 1 },
    { rowX2: 3, colX2: 7,  layer: 1 }, { rowX2: 3, colX2: 9,  layer: 1 }, { rowX2: 3, colX2: 11, layer: 1 },
    { rowX2: 5, colX2: 1,  layer: 1 }, { rowX2: 5, colX2: 3,  layer: 1 }, { rowX2: 5, colX2: 5,  layer: 1 },
    { rowX2: 5, colX2: 7,  layer: 1 }, { rowX2: 5, colX2: 9,  layer: 1 }, { rowX2: 5, colX2: 11, layer: 1 },
    { rowX2: 7, colX2: 1,  layer: 1 }, { rowX2: 7, colX2: 3,  layer: 1 }, { rowX2: 7, colX2: 5,  layer: 1 },
    { rowX2: 7, colX2: 7,  layer: 1 }, { rowX2: 7, colX2: 9,  layer: 1 }, { rowX2: 7, colX2: 11, layer: 1 },
    { rowX2: 2, colX2: 3,  layer: 2 }, { rowX2: 2, colX2: 5,  layer: 2 }, { rowX2: 2, colX2: 7,  layer: 2 },
    { rowX2: 4, colX2: 3,  layer: 2 }, { rowX2: 4, colX2: 5,  layer: 2 }, { rowX2: 4, colX2: 7,  layer: 2 },
    { rowX2: 6, colX2: 3,  layer: 2 }, { rowX2: 6, colX2: 5,  layer: 2 }, { rowX2: 6, colX2: 7,  layer: 2 },
    { rowX2: 3, colX2: 4,  layer: 3 }, { rowX2: 3, colX2: 6,  layer: 3 },
  ],
};
